const FILESPACES_KEY_BASE = 'filespaces';
export const FilespacesKeyFactory = {
    all: () => [FILESPACES_KEY_BASE],
    byWorkspace: (workspaceId) => [
        ...FilespacesKeyFactory.all(),
        workspaceId,
    ],
    exact: (workspaceId, filespaceId) => [...FilespacesKeyFactory.byWorkspace(workspaceId), filespaceId],
};
